import { cn } from "@/lib/utils";
import { Icon } from "@/components/ui/icon";

/**
 * Inline credit cost shown next to a reveal/enrich action — a bullet
 * separator, the gold credit coin, and the credit count. Replaces the older
 * "(N credits)" parenthetical so the cost reads as a distinct, scannable tag.
 */
export function ContactCreditCost({
  credits,
  className,
}: {
  credits: number;
  className?: string;
}) {
  return (
    <span className={cn("flex shrink-0 items-center gap-1", className)}>
      <span aria-hidden className="opacity-40">
        &bull;
      </span>
      <Icon name="IconCoin1" size={12} className="shrink-0 text-ai" />
      <span className="tabular-nums">
        {credits} {credits === 1 ? "credit" : "credits"}
      </span>
    </span>
  );
}
